var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgIcon',{staticStyle:{"stroke-width":"unset"},attrs:{"viewBox":"0 0 30 28","fill":"none"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"0.5","y":"0.5","width":"29","height":"27","rx":"1.5","stroke":"#BBB"}}),_c('rect',{attrs:{"x":"6","y":"6","width":"18","height":"16","rx":"0.5","fill":"var(--g-color-primary)","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }